import cn from 'classnames'
import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type SubmenuSectionProps = {
  title: string
  isWide?: boolean
  isContentSized?: boolean
}

export const SubmenuSection: FC<React.PropsWithChildren<SubmenuSectionProps>> = ({
  title,
  isWide,
  isContentSized,
  children,
}) => (
  <>
    <div className={cn('item', isWide && 'wide', isContentSized && 'content-sized')}>
      <div className="title">
        <Text variant={TextVariant.h6} color={theme.palette.text.white}>
          {title}
        </Text>
      </div>
      {children}
    </div>

    <style jsx>{`
      .item {
        flex: 1;
      }
      .item:not(:last-child, .wide) {
        max-width: 315px;
      }
      .content-sized {
        flex: 0 1 auto;
      }
      .item + .item {
        margin-left: ${theme.spacing[5]};
      }
      .title {
        margin-bottom: ${theme.spacing[3.5]};
      }
      @media ${TABLET_SCREENSIZE} {
        .item:not(:last-child, .wide) {
          max-width: 100%;
        }
        .item + .item {
          margin-left: 0;
          margin-top: ${theme.spacing[5.5]};
        }
      }
    `}</style>
  </>
)
